/* global System */
// register component(s) with react habitat

export default { Stellenausschreibungen: () => System.import('./index') }
